import React from 'react'
import ClientNotificationsManagement from '../../admin/ClientNotificationsManagement'
import V3PageBridgeFrame from '../V3PageBridgeFrame'

export default function V3ClientNotificationsManagementPage() {
  return <V3PageBridgeFrame><ClientNotificationsManagement /></V3PageBridgeFrame>
}

